export default __webpack_public_path__ + "static/media/withAudio.f00f635a.png";